import { render, staticRenderFns } from "./GoogleDrive.vue?vue&type=template&id=36454d80"
import script from "./GoogleDrive.vue?vue&type=script&lang=js"
export * from "./GoogleDrive.vue?vue&type=script&lang=js"
import style0 from "./GoogleDrive.vue?vue&type=style&index=0&id=36454d80&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports